import React from 'react';
import { SkeletonRegistryCategory } from '../../../registry/skeleton/SkeletonRegistryCategory';
import { SkeletonRegistryItem } from '../../../registry/skeleton/SkeletonRegistryItem';
import { AttachedSound_ } from '../components/AttachedSound/AttachedSound_';
export class RareSkeletonsVisibleSound extends SkeletonRegistryCategory {
    label = 'Sound';
    constructor(parent) {
        super(parent);
        super.init();
    }
    defaultSoundStructure = () => new SkeletonRegistryItem({
        jsx: ({ actor }) => {
            return React.createElement(AttachedSound_, { sound: actor });
        }
    });
}
